module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationpage",
    attrs: {
      "id": "d7e79"
    }
  }, [_c('h1', {
    staticClass: "chapno"
  }), _c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "d7e80"
    }
  }, [_vm._v("Dedication and Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationtext"
  }, [_vm._v("This book is dedicated to all of the passionate people who care about helping our aging population maintain a good quality of life and stay in the homes and neighborhoods that they cherish. We cheer you on during these changing times.")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationtext"
  }, [_vm._v("Thank you to Ed Clafin and Adams Media for believing that two heads are better than one even when those two heads are married. Reverse mortgages are often a family matter, and we felt that writing this book together enabled us to present a more complete picture of the emotional and financial challenges facing potential reverse mortgage borrowers.")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationtext"
  }, [_vm._v("We would each like to thank our coauthor for limitless energy and encouragement through another project together. May we continue to look outward together in the same direction, and keep our sense of humor.")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationtext"
  }, [_vm._v("Thank you to our two amazing sons, Kai and Cary, for teaching us why people get so attached to their homes; Lindsay Mulvey, for immeasurable assistance with the manuscript; Gregg Anderson, for the inspiring limerick; Gregory Daries, for making pictures that speak a thousand words; Jessica Hoover, for playing monkey and the barrel game while Mommy writes downstairs; Judy Fogler, for teaching that laughter improves all projects; and Sandy and Dorothy Kraemer, for providing never-ending inspiration and love to our family.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04263c6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Krae_9781440501029_epub_ded.vue
// module id = 69
// module chunks = 0